import type { FC } from "react";
import { useParams } from "react-router";
import { FollowUpWrapper } from "../../modules/follow-up/component/follow-up-wrapper";
import type { FollowUpMomentDetailsConfig } from "../../modules/follow-up/hooks/use-follow-up-moment-details";
import { Page } from "../../modules/layout/components/page";
import type { UUID } from "../../utils/uuid";
import NotFound from "../not-found";

type FollowUpPageProps = {
  config?: "from_moment" | "from_survey";
};

const FollowUpPage: FC<FollowUpPageProps> = ({ config }) => {
  const { id, moment_id, survey_id } = useParams() as {
    id?: UUID;
    moment_id?: UUID;
    survey_id?: UUID;
  };

  const wrapperConfig = makeWrapperConfig(config, id, moment_id, survey_id);

  if (!wrapperConfig) return <NotFound />;

  return (
    <Page title="Follow-Up | ChangeEngine" sx={{ height: "100%" }}>
      <FollowUpWrapper config={wrapperConfig} />
    </Page>
  );
};

function makeWrapperConfig(
  config: FollowUpPageProps["config"],
  id?: UUID,
  moment_id?: UUID,
  survey_id?: UUID,
): FollowUpMomentDetailsConfig | null {
  if (config === "from_survey" && moment_id && survey_id) {
    return { type: "from_survey" as const, data: { moment_id, survey_id } };
  }

  if (config === "from_moment" && moment_id) {
    return { type: "from_moment" as const, data: { moment_id } };
  }

  if (id) {
    return { type: "follow_up" as const, data: id };
  }

  return null;
}

export default FollowUpPage;
